import base64 from "base-64";
import decodeJWT from "jwt-claims";
import GovBr from "../tools/govbr.js";

export function getUrlGovBr(){
    const random = Math.floor(Math.random() * 10000) + 1;
    const url = GovBr.URL_PROVIDER + "/authorize?response_type=code&client_id=" + 
                GovBr.CLIENT_ID + "&scope=" + GovBr.SCOPES +
                "&redirect_uri=" + GovBr.REDIRECT_URI +
                "&nonce=" + random + "&state=" + random;
    return url
}

export async function getToken(code){
    const basic_encode = base64.encode(`${GovBr.CLIENT_ID}:${GovBr.SECRET}`);
    const basic = `Basic ${basic_encode}`;
    const url = GovBr.URL_PROVIDER+
        "/token?grant_type=authorization_code&code=" + code + 
        "&redirect_uri=" + GovBr.REDIRECT_URI; 
    let dados = [];
    let status = '';

    try {
        const res = await fetch(url, {
            method: "post",
            headers: {
              Authorization: `${basic}`
            }
          })
          .then(function (response) {
            status = response.status;
            return response;
          });
        if (status === 200){
            const resJson = await res.json();
            console.log(resJson);
            resJson.claims = decodeJWT(resJson.id_token);
            console.log(resJson.claims);
            dados = [status,
                    resJson.access_token,
                    resJson.claims.sub,
                    resJson.claims.name,
                    resJson.claims.phone_number,
                    resJson.claims.email,
                    resJson.claims.email_verified,
                    resJson.claims.phone_number_verified];
            console.log(dados);
        } else {
            dados[0]=status;
        }
    } catch(e){
        console.log(e.message);
        dados[0]="9999";
        dados[1]= e.message;
    }
    return dados;
}
export function logout(){
    //window.location="https://sso.staging.acesso.gov.br/logout?post_logout_redirect_uri=localhost:3000";
    window.location=GovBr.URL_PROVIDER+
        "/logout?post_logout_redirect_uri=https://"+
        GovBr.CLIENT_ID+"/Logout";
}